export function postosInRequest(params = {}) {
  return {
    type: '@posto/POSTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findPosto(idposto) {
  return {
    type: '@posto/FIND_POSTO',
    payload: { idposto },
  };
}

export function failedRequest() {
  return {
    type: '@posto/FAILED_REQUEST',
  };
}

export function deletePosto(idposto, params) {
  return {
    type: '@posto/DELETE_POSTO',
    payload: { idposto, params },
  };
}

export function updatePosto(posto, params) {
  return {
    type: '@posto/UPDATE_POSTO',
    payload: { posto, params },
  };
}

export function storePosto(posto, params) {
  return {
    type: '@posto/STORE_POSTO',
    payload: { posto, params },
  };
}

export function successInRequest(
  postos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@posto/SUCCESS_IN_REQUEST',
    payload: { postos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(posto) {
  return {
    type: '@posto/SUCCESS_REQUEST',
    payload: { posto },
  };
}

export function successRemove(params) {
  return {
    type: '@posto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@posto/RECORD_FILTERING',
    payload: { params },
  };
}
